import React from 'react';
import './Prompt.less';

export const Prompt = ({children, isAndroid}) => {
	return <div className={`prompt ${
		isAndroid ? 'prompt--android' : ''
	}`}>
		<div className="prompt__contents">{children}</div>
		<div className="prompt__connector"></div>
	</div>;
};
